export const INVEST_ETF_WORTHS_BASE_URL =
  "https://charonyu-etf-net-worth-pwa.netlify.app/api";
export const TEST_API_URL = "http://localhost:8080/api";

export const STOCK_COMPANY_ARRAY = [
  "街口",
  "台新",
  "第一金",
  "新光",
  "中信",
  "統一",
  "FT",
  "凱基",
  "富邦",
  "元大",
  "國泰",
  "永豐",
  "FH",
  "大華",
  "群益",
  "兆豐",
];
